export const environment = {
  production: true,
  buildId: '2776418682318961',
  configFile: 'config.json',
};
